export const API_DOMAIN =
    "https://plupnmpu7h.execute-api.eu-west-3.amazonaws.com/V1";

export const API_DEFAULT_HEADERS = (sessionToken: string) => {
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionToken}`,
    };
};
